import styles from './downloadPaymentReceiptPDFModal.module.css'
import { fileHelpers, usePDFActions } from "../../../../../features/files"
import { Modal, ModalId, FileTile, FileType } from "../../../../../features/ui"
import { SaleOperation } from '../../../../sales'
import { useEffect, useState } from "react"
import { CreditPayment } from '../../../state/types'
import { PaymentReceiptPDF } from '../payment-receipt-pdf/paymentReceiptPDF'

type Props = {
    operation?: SaleOperation
    creditPayment?: CreditPayment
}

export const DownloadPaymentReceiptPDFModal = (props: Props) => {
    const { operation, creditPayment } = props

    const [pdfName, setPdfName] = useState<string>()
    
    const { operationReceiptFileName, creditPaymentReceiptFileName } = fileHelpers

    const { generatePDF, printPDF, isPrinting } = usePDFActions()

    useEffect(() => {
        if (operation) {
            setPdfName(operationReceiptFileName(operation))
        } else if (creditPayment) {
            setPdfName(creditPaymentReceiptFileName(creditPayment.code))
        }
    }, [operation, creditPayment])

    const pdfId = 'payment-receipt-pdf'

    const onSubmit = () => {
        if (pdfName) generatePDF(pdfId, pdfName)
    }

    const renderHiddenPDF = () => operation || creditPayment ? (
        <div className={styles.hidden}>
            <PaymentReceiptPDF
                id={pdfId}
                operation={operation}
                creditPayment={creditPayment}
            />
        </div>
    ) : <></>

    return (
        <Modal
            modalId={ModalId.DOWNLOAD_PAYMENT_RECEIPT_PDF}
            title="Descargar Recibo"
            submitLabel="Descargar"
            submitIcon="download"
            onSubmit={onSubmit}
            secondaryLabel="Imprimir"
            secondaryIcon="printer"
            disableSecondary={isPrinting || !pdfName}
            onSecondarySubmit={() => printPDF(pdfId)}
        >
            <FileTile fileType={FileType.PDF} fileName={pdfName}/>
            {renderHiddenPDF()}
        </Modal>
    )
}
